module.exports = __webpack_public_path__ + "static/media/english.620f1de0.svg";